export const THEME_KEY = 'cube-path:theme:v1';
export const THEME_MODES = Object.freeze(['system', 'light', 'dark']);

export function normalizeThemePreference(value) {
  return THEME_MODES.includes(value) ? value : 'system';
}

export function loadThemePreference(storage = window.localStorage) {
  try {
    return normalizeThemePreference(storage.getItem(THEME_KEY));
  } catch {
    return 'system';
  }
}

export function saveThemePreference(preference, storage = window.localStorage) {
  const normalized = normalizeThemePreference(preference);
  storage.setItem(THEME_KEY, normalized);
  return normalized;
}

export function resolveTheme(preference, prefersDark) {
  const normalized = normalizeThemePreference(preference);
  return normalized === 'system' ? (prefersDark ? 'dark' : 'light') : normalized;
}

export class ThemeManager {
  constructor({
    storage = window.localStorage,
    documentElement = document.documentElement,
    matchMedia = window.matchMedia.bind(window),
    onChange = (_theme) => {},
  } = {}) {
    this.storage = storage;
    this.documentElement = documentElement;
    this.media = matchMedia('(prefers-color-scheme: dark)');
    this.onChange = onChange;
    this.preference = loadThemePreference(storage);
    this.handleSystemChange = () => {
      if (this.preference === 'system') this.apply();
    };
    this.media.addEventListener?.('change', this.handleSystemChange);
    this.apply();
  }

  apply() {
    const resolved = resolveTheme(this.preference, this.media.matches);
    this.documentElement.dataset.theme = resolved;
    this.documentElement.dataset.themePreference = this.preference;
    this.documentElement.style.colorScheme = resolved;
    this.onChange({ preference: this.preference, resolved });
    return resolved;
  }

  setPreference(preference) {
    this.preference = saveThemePreference(preference, this.storage);
    return this.apply();
  }

  reset() {
    this.storage.removeItem(THEME_KEY);
    this.preference = 'system';
    return this.apply();
  }

  dispose() {
    this.media.removeEventListener?.('change', this.handleSystemChange);
  }
}
